import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=7adca3fc&scoped=true&"
import script from "./forget-pwd.vue?vue&type=script&lang=ts&"
export * from "./forget-pwd.vue?vue&type=script&lang=ts&"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=7adca3fc&prod&lang=scss&scoped=true&"
import style1 from "./forget-pwd.vue?vue&type=style&index=1&id=7adca3fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adca3fc",
  null
  
)

export default component.exports